// import { getQueryString } from '@/utils'
import {
    getLimitIncreaseApplyStatus,
    getMarginLimitResultConfirm,
    getSubAcctInfo,
    getLimitAutoIncreaseStatus,
    setLimitAutoIncrease,
} from '@/apis/modules/margin'

const state = () => ({
    currentLimit: 0,
    accountType: 0,
    status: 1, // 1 开启 2 关闭
    autoMarginLimit: 0, //当前自动审批额度
    resultViewed: 1, // 0 完成页 1 初始提交页
    purchasingData: {}, // 融资申请数据
})

const getters = {}

const mutations = {
    updateCurrentLimit(state, limit) {
        state.currentLimit = limit ?? 0
    },
    updateAccountType(state, type) {
        state.accountType = type ?? 0
    },
    updateLimitAuto(state, status) {
        state.status = status ?? 1
    },
    updateAutoMarginLimit(state, limit) {
        state.autoMarginLimit = limit ?? 0
    },
    updateResultViewed(state, viewed) {
        state.resultViewed = viewed ?? 1
    },
    updatePurchasingData(state, data) {
        state.purchasingData = data ?? {}
    },
}

const actions = {
    async getLimitStatus({ commit }) {
        const { data = {} } = await getLimitIncreaseApplyStatus()

        if (data.result) {
            commit('updateCurrentLimit', data.result.currentMarginLimit)
            commit('updateAutoMarginLimit', data.result.autoMarginLimit)
            commit('updatePurchasingData', data.result)
            commit('updateResultViewed', data.result.resultViewed)
            if (data.result.resultViewed === 0) {
                await getMarginLimitResultConfirm({ id: data.result.id })
            }
        }

        return data
    },
    async getAccountType({ commit }) {
        const { data = {} } = await getSubAcctInfo()

        if (data.result) {
            commit('updateAccountType', data.result.type)
        }

        return data
    },
    async getLimitAutoStatus({ commit }) {
        const { data = {} } = await getLimitAutoIncreaseStatus()
        if (data.result) {
            commit('updateLimitAuto', data.result.status)
        }
        return data
    },
    async setLimitAutoStatus({ commit }, status) {
        console.log(status, 'setLimitAutoStatus')
        const { data = {} } = await setLimitAutoIncrease(status)
        if (data.result) {
            commit('updateLimitAuto', status)
        }
        return data
    },
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
